const makeRelAttribute = (config) => {
    if (!config?.href)
        return '';
    const withNoReferrerParams = config.href.indexOf('promo=1') > -1 || config.href.indexOf('noreferrer=1') > -1;
    // @ts-expected-error TODO исправить после обновления типизации
    const noReferrer = withNoReferrerParams || config.noReferrer ? 'noreferrer' : undefined;
    const noFollow = config.nofollow ? 'nofollow' : undefined;
    const rel = [noReferrer, noFollow].filter((tag) => tag).join(' ');
    return rel || undefined;
};

export { makeRelAttribute };
//# sourceMappingURL=links.js.map
